import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import { backgroundColor, primaryColor, secondaryColor } from "../../theme";

export const Nav = styled.nav`
  background: ${({ isTransparent, scrollNav }) =>
    isTransparent
      ? scrollNav
        ? backgroundColor
        : "transparent"
      : backgroundColor};
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  transition: all 0.2s ease-in-out;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogoContainer = styled(LinkR)`
  justify-self: flex-start;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 8px;
  /* font-weight: bold; */
  text-decoration: none;
`;

export const NavLogo = styled.img`
  width: 6em;
  height: 3em;
`;

export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    /* color: #fff; */
    color: ${primaryColor};
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

//links para el scroll
export const NavLinksS = styled(LinkS)`
  color: ${primaryColor};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &.active {
    border-bottom: 4px solid ${secondaryColor};
  }

  &:hover {
    color: ${secondaryColor};
    text-decoration: none;
  }
`;

//links para el router
export const NavLinksR = styled(LinkR)`
  color: ${primaryColor};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:active {
    border-bottom: 4px solid ${secondaryColor};
  }

  &:hover {
    color: ${secondaryColor};
    text-decoration: none;
  }
`;

export const ExternalLink = styled.a`
  color: ${primaryColor};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:active {
    border-bottom: 4px solid ${secondaryColor};
  }

  &:hover {
    color: ${secondaryColor};
    text-decoration: none;
  }
`;
